export default {
  // Landing
  create_account: 'Create an account',
  landing_subtitle:
    'If you have an account other than TG, please click the "Already have an account" button to login.',
  agree_privacy: 'I have read and agree to the',
  privacy_policy: 'Privacy Policy',
  and: 'and',
  terms_of_service: 'Terms of Service.',
  agree_required: 'Please agree to the Privacy Policy and Terms',
  already_have_account: 'Already have an account',

  // Page titles
  sign_in_title: 'Sign In',
  sign_up_title: 'Sign Up',
  tg_quick_title: 'TG Quick Sign In',
  bind_account_password: 'Bind account password',

  // Field placeholders
  account_placeholder: 'Please enter your account',
  password_placeholder: 'Please enter your password',
  account_signup_placeholder: 'Account (6-10 alphanumeric combination)',
  password_signup_placeholder: 'Please enter a password of at least 8 characters',
  confirm_password_placeholder: 'Please enter your password again',
  tg_contact_placeholder: 'Telegram username or Telegram mobile number',
  invitation_placeholder: 'Please enter your invitation code (optional)',
  tg_password_placeholder: 'Please enter a password of at least 8 characters',

  // Field validation errors
  account_required: 'Account is required',
  account_invalid: 'Account must be 6-10 alphanumeric characters',
  account_no_special_chars: 'Special characters are not allowed',
  account_banned_word: 'This account name is not allowed',
  password_required: 'Password is required',
  password_invalid: 'Password must be at least 8 characters and include an uppercase letter, a lowercase letter and a number',
  password_weak: 'Password is too easily guessed. Avoid simple sequences and common passwords.',
  confirm_required: 'Please confirm your password',
  confirm_mismatch: 'Passwords do not match',
  tg_contact_required: 'Telegram username or mobile is required',
  tg_username_invalid: 'Invalid Telegram username',
  tg_phone_invalid: 'Phone number must be 2–19 digits',

  // Actions
  sign_in: 'Sign In',
  sign_up: 'Sign Up',
  remember_password: 'Remember the password',
  forgot_password: 'Forgot password？',
  or: 'Or',
  tg_quick_sign_in: 'TG Quick Sign In',
  start_now: 'Start Now',
  sign_now: 'Sign Now',

  // Cross-links
  new_to_hg: 'New to 99H.COM?',
  go_sign_up: 'Sign Up',
  already_member: 'Already have an account？',
  go_sign_in: 'Sign In',

  // Toast messages
  login_success: 'Login successful',
  login_failed: 'Login failed',
  sign_up_failed: 'Sign up failed',
  sign_in_failed: 'Sign in failed',
  // Backend code 9229 — "too many failed login attempts → temporary lock".
  account_locked: 'Your account has been temporarily suspended. Please try again later.',
  // Backend codes 9371/9372/9373 — rate-limited; 9374 — account frozen.
  pw_rate_limit_5min: 'Too many password attempts. Please try again in 5 minutes.',
  pw_rate_limit_10min: 'Too many password attempts. Please try again in 10 minutes.',
  pw_rate_limit_30min: 'Too many password attempts. Please try again in 30 minutes.',
  account_frozen: 'Account Freezed! Please contact Customer service.',

  tg_session_unavailable: 'Telegram session not available',
  tg_init_data_missing: 'Telegram init data is missing',

  // 2FA security verification sheet (backend code 9228 triggers it; 9223 = wrong code)
  two_fa_sheet_title: 'Security verification',
  two_fa_code_label: 'Google verification code',
  two_fa_code_placeholder: 'Enter 6-digit code',
  two_fa_paste: 'Paste',
  two_fa_cancel: 'Cancel',
  two_fa_confirm: 'Confirm',
  two_fa_invalid: 'Incorrect verification code',

  // Backend: wrong account/password combination (distinct from generic login failure)
  login_wrong_credentials: 'Incorrect account or password',
  // Backend codes 9003 (register) / 9194 (telegram sign-up) — account already taken.
  account_in_use: 'This account is already in use, please try a different one',

  // GeeTest: the backend rejected the widget result, or the verify call
  // itself failed — either way the captcha did not pass.
  captcha_failed: "Captcha verification failed, please try again",

  // Shown while the Mini App signs the visitor in automatically
  // on open (useTelegramAutoSignIn).
  signing_in: 'Signing in…',

  // Shown while the hCaptcha challenge is being prepared.
  captcha_loading: 'Loading verification…',
};
